import { Box } from '@mui/system'
import React, { PropsWithChildren } from 'react'

const FlexWrapContainer = ({ children }: PropsWithChildren) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        width: 'calc(100% + 1rem)',
        height: 'auto',
        ml: -1,
        paddingBottom: 2,
      }}
    >
      {children}
    </Box>
  )
}

export default FlexWrapContainer
